import React from "react";

import Navbar from "components/Navbar";

export default function ConfirmPage() {
    const queryParameters = new URLSearchParams(window.location.search)
    const order = queryParameters.get("order")
    const info = queryParameters.get("info")

    return (
        <>
            <Navbar />
            <div className="container py-3">
                <h1>Pedido confirmado</h1>
                <p>Um email de confirmação será enviado para o email cadastrado.</p>
            </div>
        </>
    )
}
